export const PERMS = {
    READ: 'driver_documents.read',
    UPDATE: 'driver_documents.update',
    DELETE: 'driver_documents.delete',
    CREATE: 'driver_documents.create',
    EXPORT: 'driver_documents.export',
}
